module.exports = __webpack_public_path__ + "media/images/page/photo_s4-9117e05ae9ab3b70603096cd3be58b5c.jpg";